export const SPEAKER_DIVINE = "PlayBees Speaker Divine";
export const SPEAKER_PODCAST = "PlayBees Speaker Podcast";

export const SUB_MENU_HIGHLIGHT = {
  HOME: "home",
  TNC: "tnc",
};
